/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CompanySelect_company$ref: FragmentReference;
declare export opaque type CompanySelect_company$fragmentType: CompanySelect_company$ref;
export type CompanySelect_company = {
  +id: string,
  +name: string,
};
export type CompanySelect_company$data = CompanySelect_company;
export type CompanySelect_company$key = {
  +$data?: CompanySelect_company$data,
  +$fragmentRefs: CompanySelect_company$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CompanySelect_company",
  "type": "Company",
  "metadata": {
    "mask": false
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bded3d9e17beca039c2ed51d5808c694';
module.exports = node;
